exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ng2-file-input .ng2-file-input-drop-container {\n  min-width: 200px;\n  min-height: 50px;\n  border: 2px dashed #333;\n  padding: 7px;\n  background-color: red; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/backend/src/app/phone/tools/elements/modals/cache-delete-from-file-modal/cache-delete-from-file-modal.component.scss
// module id = ../../../../../src/app/phone/tools/elements/modals/cache-delete-from-file-modal/cache-delete-from-file-modal.component.scss
// module chunks = main